import React, { useEffect, useState } from "react";
import "../styles/Thankyou.scss";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated, useQuery } from "../helpers/functions";
import Button from "../components/Button";
import { config } from "../config/config";
import c from "../helpers/constants";
import history from "../helpers/history";
import {
  CheckCircle,
  CheckSquare,
  CircleFilled,
  CrossCircle,
  CrossCircleWhite,
} from "../helpers/icons";
import { getThankyou } from "../selectors/Thankyou";
import { fetchThankyou } from "../actions/Thankyou";

const PriceChanged = () => {
  const [params, setParams] = useState<any | null>(null);

  const details = useSelector(getThankyou);
  const dispatch = useDispatch();

  console.log(details);

  const query = useQuery();

  useEffect(() => {
    console.log(params);
    if (null == params) {
      let p = {
        e: query.get("e") || "",
        a: query.get("a") || "",
        t: query.get("t") || "",
        s: query.get("s") || "",
      };
    }
  }, []);

  const backToStatements = () => {
    if(isAuthenticated()) {
      history.push(c.APP_ROUTES.ORDERS);
    } else {
      history.push(c.APP_ROUTES.LOGIN + '?returnUrl=' + c.APP_ROUTES.ORDERS);
    }
  };

  const backToLogin = () => {
    history.push(c.APP_ROUTES.LOGIN);
  };

  return (
    <div className="thankyou">
      <div className="container">
        <div className="thankyou-header text-white">
          <span className="ml-2">Your Payit Link has Expired</span>
        </div>

        <div className="thankyou-card">
          <div className="thankyou-card-header">
            <h2 className="thankyou-card__total text-dark-grey mb-1">
              A change has been made to your order
            </h2>
          </div>
          <div className="thankyou-card-body">
            <div className="text-dark-grey text-center">
              A change has been made to your order and the payit link is no
              longer valid.<br/>Please contact the office for a new link or click to
              visit your orders on the portal to pay from there.
            </div>
          </div>

          <div className="text-center mt-3 no-print">
            <div className="d-flex justify-content-center align-items-center action-buttons pb-3">
              <div className="mr-1">
                <Button
                  type="orange"
                  size="md"
                  shape="chamfer"
                  text="View Order History"
                  onClick={() => backToStatements()}
                ></Button>
              </div>

              {!isAuthenticated() && (
                <>
                  <div className="mr-1">
                    <Button
                      type="orange"
                      size="md"
                      shape="chamfer"
                      text="Back to Login"
                      onClick={() => backToLogin()}
                    ></Button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="payit-branding">
              <img src={config.payitBrand} alt="payit brand" />
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default PriceChanged;
